import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { usePlatformCapabilities } from '../config/PlatformContext';

/** Keeps signed-in users out of the sign-in screens. */
export function AuthRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div className="auth-layout">
        <div className="spinner spinner-lg" />
      </div>
    );
  }

  if (status === 'authenticated' || status === 'identity_mode') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

/**
 * Instance selection exists only where the shell can switch backends (desktop).
 * A web client is already served from its own instance's origin, so these
 * routes redirect to sign-in there.
 */
export function InstanceRoute({ children }: { children: ReactNode }) {
  const instances = usePlatformCapabilities().instances;

  if (!instances) {
    return <Navigate to="/auth/login" replace />;
  }

  return <AuthRoute>{children}</AuthRoute>;
}
